import React from 'react';
import { ArrowRightIcon, StarIcon } from 'lucide-react';
import { panelStyle } from '../../utils/imagePanel';
import { OFFER_ID, scrollToOffer } from '../../utils/scrollToOffer';
export function Hero() {
  return <header className="relative overflow-hidden border-b border-white/5 bg-ink" data-id="element-26" data-mp="qln44ddseue8">
      <div className="mx-auto grid w-full max-w-6xl gap-10 px-6 pb-16 pt-12 lg:grid-cols-[1.05fr_1fr] lg:items-center lg:gap-16 lg:pb-24 lg:pt-16" data-id="element-27" data-mp="ln268km0cmsy">
        <div data-id="element-28" data-mp="3u3ngs5uafny6">
          <p className="text-xs font-semibold uppercase tracking-[0.28em] text-gold" data-id="element-29" data-mp="3u58bpwkil8wk">
            Curly Seducción
          </p>

          <h1 className="mt-6 font-display text-4xl leading-[1.05] text-cream sm:text-5xl lg:text-6xl" data-id="element-30" data-mp="7wqb0cu4m7xl">
            El método para que tu rizo se defina solo,
            <span className="italic text-gold-soft" data-id="element-31" data-mp="2z6wrcxfhv5n"> con lo que ya tienes en casa</span>
          </h1>

          <p className="mt-6 max-w-prose text-base leading-relaxed text-sand sm:text-lg" data-id="element-32" data-mp="1jdgkq5xrdhvy">
            Seis pasos para entender tu cabello, dejar de comprar al azar y llegar al tercer día
            con el rizo definido. Guía digital de 70 páginas, lista en tu correo.
          </p>

          <div className="mt-9 flex flex-col items-start gap-3 sm:flex-row sm:items-center" data-id="element-33" data-mp="2g4y1um9n7wd2">
            <a href={`#${OFFER_ID}`} onClick={scrollToOffer} className="inline-flex items-center gap-2 rounded-full bg-gold px-8 py-4 text-sm font-semibold uppercase tracking-[0.14em] text-ink transition-colors duration-150 ease-out hover:bg-gold-soft focus:outline-none focus-visible:ring-4 focus-visible:ring-gold/40" data-id="element-34" data-mp="2l6dmid7ws0ux">
              Quiero el método
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-35" data-mp="21glfmh0cxrvr" />
            </a>
            <p className="text-xs text-sand" data-id="element-36" data-mp="26a649ig299ia">Acceso inmediato · Garantía de 30 días</p>
          </div>

          <div className="mt-8 flex items-center gap-3 border-t border-white/10 pt-6" data-id="element-37" data-mp="19q74utnn4vob">
            <span className="flex" aria-hidden="true" data-id="element-38" data-mp="1dqzeho0fd2l4">
              {[0, 1, 2, 3, 4].map(star => <StarIcon key={star} className="h-4 w-4 fill-gold text-gold" data-id="element-39" data-mp="2h1n0y2wxj3cr" />)}
            </span>
            <p className="text-sm text-sand" data-id="element-40" data-mp="2c3v0ulm4saxh">
              <span className="font-semibold text-cream" data-id="element-41" data-mp="2qtiz1dz0mtgz">4.9 / 5</span> · más de 3.400 mujeres ya
              siguen el método
            </p>
          </div>
        </div>

        <div className="h-80 w-full rounded-xl border border-gold/25 shadow-[0_30px_80px_-30px_rgba(0,0,0,0.9)] sm:h-[26rem] lg:h-[32rem]" style={panelStyle(0)} role="img" aria-label="Mujer sonriendo con rizos definidos y voluminosos" data-id="element-42" data-mp="2lwaifhtimxhu" />
      </div>
    </header>;
}